import { Badge } from "@mantine/core"

export function StatusBadge(props: {
  status: { color?: string; name: string } | undefined
}) {
  const { status } = props
  return (
    status &&
    status.name?.length > 0 && (
      <Badge color={status.color ?? undefined}>{status.name}</Badge>
    )
  )
}
